import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	@media ${Breakpoints.mobile} {
		padding: 0 var(--padding-2) var(--padding-5) var(--padding-2) !important;
	}
`;

export const PopperMenu = styled.div`
	display: flex;
	flex-direction: column;
	padding: var(--padding-2);
	background-color: var(--modal-bg-3);
	border-radius: var(--small-border-radius);
	min-width: 24rem;
	z-index: var(--z-index-2);
	box-shadow: var(--container-box-shadow);
	overflow: auto;
	gap: 1rem;
`;

export const LineChartContainer = styled.div`
	display: flex;
	flex-direction: column;
`;
